module.exports = "images/enfants_11.9ea84d68.png";